import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import template from '../../templates/FeatureInclusion/AddPreset.rt';
import * as actions from '../../actions';

function mapStateToProps(state, props) {
  return {
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    createPreset: (name, description) => dispatch(actions.featureInclusion.createPreset(name, description)),
    showAlert: (text) => dispatch(actions.messageBox_Show(true, 'error', 'Error processing request', text)),
    hideAddNewPresetPopup: () => dispatch(actions.featureInclusion.showAddNewPresetPopup(false))
  };
}

class addPreset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      description: ''
    };
  }
  render = template;

  setName = (e) => {
    this.setState({name: e.target.value});
  }
  setDescription = (e) => {
    this.setState({description: e.target.value});
  }
  doSave = () => {
    if(this.state.name.trim().length == 0) {
      this.props.showAlert('Please enter a Preset Name');
    } else {
      this.props.createPreset(this.state.name, this.state.description)
        .then(this.props.hideAddNewPresetPopup)
        .catch(this.props.showAlert);
    }
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
const AddPreset = connector(addPreset);

export { AddPreset }
export default AddPreset;
